import { render, staticRenderFns } from "./logic.vue?vue&type=template&id=45b511d4&scoped=true&"
import script from "./logic.vue?vue&type=script&lang=js&"
export * from "./logic.vue?vue&type=script&lang=js&"
import style0 from "./logic.vue?vue&type=style&index=0&id=45b511d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b511d4",
  null
  
)

export default component.exports